// Where a re-upload came from and where it returns to, so Validate Content knows
// which screen to send the user back to.
export const REUPLOAD_MODES = {
  creatives: {
    key: 'creatives',
    label: 'Creatives',
    returnTo: '/mcv/creatives',
    held: ['/mcv/creatives'],
    autoFetchDocument: false,
  },
  approval: {
    key: 'approval',
    label: 'Approval',
    returnTo: '/mcv/approval-dashboard',
    held: ['/mcv/approval-dashboard', '/mcv/approval-details'],
    autoFetchDocument: true,
  },
};

export const reuploadMode = (origin) => REUPLOAD_MODES[origin] || REUPLOAD_MODES.creatives;

export const isHeldByPendingVersion = (origin, pathname) =>
  reuploadMode(origin).held.some((path) => pathname.startsWith(path));
